var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxShowAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 8C8.60333 8 8 7.39667 8 6.66667C8 6.43067 8.06867 6.21133 8.17867 6.018C8.11867 6.01333 8.06133 6 8 6C7.47065 6.00349 6.96397 6.21533 6.58965 6.58965C6.21533 6.96397 6.00349 7.47065 6 8C6 9.09467 6.90533 10 8 10C9.094 10 10 9.09467 10 8C10 7.93867 9.98667 7.88133 9.982 7.82133C9.78867 7.93133 9.56933 8 9.33333 8Z",
    fill: "#495057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99954 3.33594C2.91088 3.33594 1.38154 7.74727 1.36754 7.79194L1.29688 8.0026L1.36688 8.21327C1.38154 8.25794 2.91088 12.6693 7.99954 12.6693C13.0882 12.6693 14.6175 8.25794 14.6315 8.21327L14.7022 8.0026L14.6322 7.79194C14.6175 7.74727 13.0882 3.33594 7.99954 3.33594ZM7.99954 11.3359C4.43221 11.3359 3.05021 8.77194 2.71554 8.0026C3.05154 7.2306 4.43421 4.66927 7.99954 4.66927C11.5669 4.66927 12.9489 7.23327 13.2835 8.0026C12.9475 8.7746 11.5649 11.3359 7.99954 11.3359Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxShowAlt);
export default __webpack_public_path__ + "static/media/bx-show-alt.dd73cb20fe8a763c1a6ffa2bec588ddb.svg";
export { ForwardRef as ReactComponent };